import axios from 'axios';
import { AnyIfEmpty } from "react-redux";
import { GET_KIOSK_STATUS_FAILURE, GET_KIOSK_STATUS_REQUEST, GET_KIOSK_STATUS_SUCCESS } from "../constants/kiosk-status.constants";
import { Dispatch } from "react";

const getKioskStatusRequest = () => {
    return {
        type: GET_KIOSK_STATUS_REQUEST,
    };
};

const getKioskStatusSuccess = (kioskData: AnyIfEmpty<object>) => {
    return {
        type: GET_KIOSK_STATUS_SUCCESS,
        payload: kioskData,
    };
};

const getKioskStatusFailure = (error: string) => {
    return {
        type: GET_KIOSK_STATUS_FAILURE,
        payload: error,
    };
};

export const getKioskStatus = (locationId?: string, startDate?: string, endDate?: string) => {
    return async (dispatch: Dispatch<AnyIfEmpty<object>>) => {
        dispatch(getKioskStatusRequest());
        return await axios
            .get(`locker/image-capture-status`, {
                params: {
                    locationId,
                    startDate,
                    endDate,
                },
            })
            .then((response) => {
                dispatch(getKioskStatusSuccess(response.data.data));
            })
            .catch((error) => dispatch(getKioskStatusFailure(error.message)));


    };
};
